import { useEffect } from "react";

const NEW_MP_URL = "https://mp2.easyrice.ai/login";

export default function App() {
  useEffect(() => {
    document.title = "EASYRICE MP1 แจ้งย้ายเว็บไซต์";
  }, []);

  return (
    <main className="migration-page">
      <section className="migration-card">
        <span className="migration-badge">EASYRICE MP</span>
        <h1 className="migration-heading">
          ประกาศแจ้งลูกค้า MP1:
          <br />
          เปลี่ยนแปลงเว็บไซต์ใหม่
        </h1>

        <p className="migration-lead">
          EASYRICE
          จะดำเนินการเปลี่ยนแปลงลิงก์เว็บไซต์สำหรับการเข้าใช้งานระบบโปรแกรมตรวจสอบสายพันธุ์ข้าวเปลือก
          จากเดิมเข้าสู่ระบบผ่านลิงก์{" "}
          <span className="migration-highlight">MP หรือ MP1</span>{" "}
          เป็นการเข้าสู่ระบบผ่านลิงก์ <span className="migration-highlight">MP2</span>{" "}
          แทน
        </p>

        <p className="migration-paragraph">
          การเปลี่ยนแปลงดังกล่าวเป็นเพียงการปรับเปลี่ยนลิงก์เว็บไซต์เท่านั้น
          รูปแบบการใช้งานทั้งหมดยังคงเหมือนเดิมทุกประการ
        </p>

        <p className="migration-paragraph">
          ผู้ใช้งานสามารถเข้าใช้งานผ่านลิงก์ใหม่ได้ตามปกติ โดยใช้
          &quot;ชื่อผู้ใช้&quot; และ &quot;รหัสผ่าน&quot; เดิมในการเข้าสู่ระบบ
        </p>

        <div className="migration-link-panel">
          <p className="migration-link-label">ลิงก์เข้าใช้งานใหม่</p>
          <a href={NEW_MP_URL} className="migration-link">
            {NEW_MP_URL}
          </a>
        </div>

        <div className="migration-footer">
          <p className="migration-contact-title">ติดต่อทีมงาน</p>
          <p className="migration-contact-text">
            LINE: @easyrice (มี @ ด้านหน้า)
            <br />
            โทร: 02-700-4399 กด 2
          </p>
        </div>
      </section>
    </main>
  );
}
